import { matchPath } from 'react-router-dom';

import { ChangePasswordPopup } from '~/popups/ChangePasswordPopup';
import { ContactPopup } from '~/popups/ContactPopup';
import { EmailRegisterPopup } from '~/popups/EmailRegisterPopup';
import {
  LegalPopup,
  PrivacyAppPopup,
  PrivacyPopup,
  TermsPopup,
  WithdrawalPopup,
} from '~/popups/LegalPopups';
import { LoginPopup } from '~/popups/LoginPopup';
import LoginRedirectPopup from '~/popups/LoginRedirectPopup';
import LoginRequiredPopup from '~/popups/LoginRequiredPopup';
import { NewsletterPopup } from '~/popups/NewsletterPopup';
import { PasswordResetCodePopup } from '~/popups/PasswordResetCodePopup';
import { PasswordResetPopup } from '~/popups/PasswordResetPopup';
import { RedeemCodePopup } from '~/popups/RedeemCodePopup';
import { RegisterPopup } from '~/popups/RegisterPopup';
import { RequestPasswordResetPopup } from '~/popups/RequestPasswordResetPopup';
import { RequestVerificationCodePopup } from '~/popups/RequestVerificationCodePopup';
import { TermsConsentPopup } from '~/popups/TermsConsentPopup';
import { TutorialsPopup } from '~/popups/TutorialsPopup';
import { UserDetailsPopup } from '~/popups/UserDetailsPopup';
import { VerifyEmailPopup } from '~/popups/VerifyEmailPopup';
import { VersionPopup } from '~/popups/VersionPopup';
import {
  ALL_TUTORIALS_PATH,
  CHANGE_PASSWORD_PATH,
  CONTACT_PATH,
  EMAIL_REGISTER_PATH,
  EMAIL_VERIFICATION_PATH,
  LEGAL_PATH,
  LOGIN_PATH,
  LOGIN_REQUIRED_PATH,
  loginRedirectPathnames,
  NEWSLETTER_PATH,
  PASSWORD_RESET_CODE_PATH,
  PASSWORD_RESET_PATH,
  PRIVACY_POLICY_APP_PATH,
  PRIVACY_POLICY_PATH,
  REDEEM_CODE_PATH,
  REGISTER_PATHNAME,
  REGISTER_TERMS_PATH,
  REQUEST_EMAIL_VERIFICATION_PATH,
  REQUEST_PASSWORD_RESET_PATH,
  TERMS_PATH,
  USER_DETAILS_PATH,
  VERSION_PATH,
  WITHDRAWAL_PATH,
} from '~/routes/paths';

export const menuRoutes: Record<
  string,
  {
    order?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: (props: any) => JSX.Element;
    preventOverlayClose?: boolean;
    loginFlow?: boolean;
  }
> = {
  [LOGIN_REQUIRED_PATH]: {
    component: LoginRequiredPopup,
    order: -1,
    loginFlow: true,
  },
  [NEWSLETTER_PATH]: {
    component: NewsletterPopup,
    order: 0,
  },
  [LOGIN_PATH]: {
    component: LoginPopup,
    order: 1,
    loginFlow: true,
  },
  [REGISTER_PATHNAME]: {
    component: RegisterPopup,
    order: 2,
    loginFlow: true,
  },
  [EMAIL_REGISTER_PATH]: {
    component: EmailRegisterPopup,
    order: 3,
    loginFlow: true,
  },
  [REGISTER_TERMS_PATH]: {
    component: TermsConsentPopup,
    order: 4,
    preventOverlayClose: true,
  },
  [REQUEST_EMAIL_VERIFICATION_PATH]: {
    component: RequestVerificationCodePopup,
    order: 5,
    preventOverlayClose: true,
  },
  [EMAIL_VERIFICATION_PATH]: {
    component: VerifyEmailPopup,
    order: 6,
    preventOverlayClose: true,
  },
  [USER_DETAILS_PATH]: {
    component: UserDetailsPopup,
    order: 7,
    preventOverlayClose: true,
  },
  [REQUEST_PASSWORD_RESET_PATH]: {
    component: RequestPasswordResetPopup,
    order: 8,
    loginFlow: true,
  },
  [PASSWORD_RESET_CODE_PATH]: {
    component: PasswordResetCodePopup,
    order: 9,
    loginFlow: true,
  },
  [PASSWORD_RESET_PATH]: {
    component: PasswordResetPopup,
    order: 10,
    loginFlow: true,
  },
  [CHANGE_PASSWORD_PATH]: {
    component: ChangePasswordPopup,
    order: 11,
  },
  [REDEEM_CODE_PATH]: {
    component: RedeemCodePopup,
  },
  [ALL_TUTORIALS_PATH]: {
    component: TutorialsPopup,
  },
  [CONTACT_PATH]: {
    component: ContactPopup,
  },
  [VERSION_PATH]: {
    component: VersionPopup,
  },
  [LEGAL_PATH]: {
    component: LegalPopup,
  },
  [WITHDRAWAL_PATH]: {
    component: WithdrawalPopup,
  },
  [TERMS_PATH]: {
    component: TermsPopup,
  },
  [PRIVACY_POLICY_PATH]: {
    component: PrivacyPopup,
  },
  [PRIVACY_POLICY_APP_PATH]: {
    component: PrivacyAppPopup,
  },
};

loginRedirectPathnames.forEach((path) => {
  menuRoutes[path] = {
    component: LoginRedirectPopup,
    loginFlow: true,
  };
});
export const menuPaths = Object.keys(menuRoutes);
export const loginFlowPaths = menuPaths.filter(
  (path) => menuRoutes[path].loginFlow,
);

export function getMenuViewTransitionDirection(
  currentPath: string,
  prevPath?: string,
): 'backwards' | 'forwards' {
  if (!prevPath) {
    return 'backwards';
  }
  const currentPathOrder = menuRoutes[currentPath]?.order ?? 0;
  const prevPathOrder = menuRoutes[prevPath]?.order ?? 0;

  return currentPathOrder < prevPathOrder ? 'backwards' : 'forwards';
}

export function isMenuPopupPath(path: string): boolean {
  return !!matchPath(path, { path: menuPaths });
}
